var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.priority},[_c('em',{staticClass:"zkicon iconyouxianji",style:({color: _vm.issue.priorityColor || 'rgb(215, 215, 215)'})})])}
var staticRenderFns = []

export { render, staticRenderFns }